import { useColorScheme } from "@/hooks/useColorScheme";

export function useLayoutColors() {
  const { colorScheme } = useColorScheme();

  const base = {
    sidebar: "var(--background)",
    main: "var(--background)",
    topbar: "var(--background)",
    subnav: "var(--background)",
    content: "var(--background)",
    panel: "var(--background)",
    dialog: "var(--popover)",
    dialogOverlay: "rgba(0, 0, 0, 0.1)",
    nodeTitle: "var(--background)",
    tableHeader: "var(--background)",
    tableRow: "var(--background)",
    tableRowHover: "var(--muted)",
    card: "var(--muted)",
    chatInput: "var(--background)",
    reportCard: "var(--accent)",
    reportCardHover: "var(--secondary)",
    // What a surface carrying ``content`` lifts to under the pointer.
    contentHover: "var(--muted)",
  };

  const layoutColors = {
    ...base,
    ...(colorScheme === "light" && {
      content: "var(--muted)",
      // Half a step past ``level2``: a full step to ``level3`` is heavier than
      // this canvas wants.
      reportCard: `color-mix(in srgb, ${"var(--accent)"} 50%, ${"var(--secondary)"} 50%)`,
      // What a report's own tiles lift to under the pointer: they carry the
      // content surface, so this is one step off that.
      contentHover: "var(--accent)",
    }),
    ...(colorScheme === "dark" && {
      content: "#151719",
      // The level steps are not symmetric: one step off the near-white canvas
      // is a few points, the same step off the near-black canvas is double
      // that and lifts rather than recesses. The report card drops a level
      // here so dark separates as gently as light does.
      reportCard: "var(--muted)",
      reportCardHover: "var(--accent)",
      contentHover: "var(--muted)",
    }),
  };

  return layoutColors;
}
